import { styled } from "@mui/material";
import { Box } from "@mediaspace/shared/styled";
import { Link, Typography } from "@kaltura/ds-react-components";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";
import {useButtonAnalytics} from "@mediaspace/hooks";

// See Kms_Type_Media_Metadata_Category_Props in php
export interface MediaCategoryProps {
    categoryName: string;
    iconUrl?: string;
    actionLabel: string;
    actionUrl: string;
}

/**
 * Category context component for the media page metadata
 */
export const MediaCategory = ({categoryName, iconUrl, actionLabel, actionUrl}: MediaCategoryProps) => {

    const sendButtonAnalytics = useButtonAnalytics();

    const onLinkClick = () => {
        sendButtonAnalytics("Go to context category", ButtonClickAnalyticsType.LINK);
    }

    return <StyledContainer className="kms-ds-media-page-metadata-category">
        {iconUrl && <StyledIcon className={"kms-ds-media-page-category-icon"} style={{backgroundImage: `url(${iconUrl})`}}/>}
        <Box className={"kms-ds-media-page-category-name-and-link"}>
            <StyledLine variant={"body2Highlight"}>
                {categoryName}
            </StyledLine>
            <StyledLine variant={"body2Highlight"}>
                <Link href={actionUrl} inText={false} onClick={onLinkClick}>{actionLabel}</Link>
            </StyledLine>
        </Box>
    </StyledContainer>
};

export default MediaCategory;

const StyledContainer = styled(Box)(({theme}) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
}));

const StyledIcon = styled(Box)({
    width: 36,
    height: 36,
    borderRadius: "50%",
    overflow: "hidden",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
});

const StyledLine = styled(Typography)({
    display: "block",
});
